import React, { useState, useEffect } from 'react';

import GenericInputContainer from '../shared/GenericInputContainer';
import DisplayBoolean from './DisplayBoolean';
import EditBoolean from './EditBoolean';

const BooleanInputContainer = ({ initialValue: onPageLoadValue, syncChanges, isSwitch, isEditing, setIsEditing, isHovered }) => {
    const [value, setValue] = useState(onPageLoadValue ?? null);
    const [initialValue, setInitialValue] = useState(onPageLoadValue ?? null);

    useEffect(() => {
        setValue(onPageLoadValue);
        setInitialValue(onPageLoadValue);
    }, [onPageLoadValue]);

    const isFieldNull = value === null;

    const valueHasntChanged = () => {
        return value === initialValue;
    };

    const handleSave = async () => {
        const response = await syncChanges(value);
        if (response.success) {
            setInitialValue(value);
        }
        return response;
    };

    const handleCancel = () => {
        setValue(initialValue);
    };

    return (
        <GenericInputContainer {...{ isEditing, setIsEditing, isHovered, isFieldNull, handleSave, handleCancel, valueHasntChanged }}>
            <DisplayBoolean {...{ value }} />
            <EditBoolean {...{ value, setValue, isSwitch }} />
        </GenericInputContainer>
    );
};

export default BooleanInputContainer;
